import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Alert, Button, Col, Layout, Row, Spin,
} from 'antd';
import { autobind } from 'core-decorators';

import { handleCallback, login } from 'auth/authkit';
import { authkitSession } from 'actions/user';
import { history } from 'store/configureStore';

// Landing page for the AuthKit redirect: exchanges the authorization code for
// tokens, stores the session, and returns to wherever login started.
class AuthCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    handleCallback(window.location.search)
      .then(({ token, returnTo }) => {
        dispatch(authkitSession(token));
        history.replace(returnTo);
      })
      .catch((error) => {
        this.setState({ error: error.message });
      });
  }

  @autobind
  retry() {
    return login('/');
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return (
        <Layout className="app-loading">
          <Layout.Content>
            <Spin size="large" />
          </Layout.Content>
        </Layout>
      );
    }
    return (
      <Layout.Content>
        <Row>
          <Col span={8} offset={8} className="login-box">
            <Alert message="Sign-in failed" description={error} type="error" showIcon />
            <br />
            <div className="text-right">
              <Button type="default" onClick={this.retry}>
                Try again
              </Button>
            </div>
          </Col>
        </Row>
      </Layout.Content>
    );
  }
}

AuthCallback.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(AuthCallback);
